import { type FC } from 'react';
import dayjs from 'dayjs';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// screen
import type { StructuredDataInfo } from 'modules/map/components/teacher-menu/types';
import { SMALL_FONT_SIZE } from 'modules/map/components/pdf-print-form/utils';
import PdfFormNote from 'modules/map/components/pdf-print-form/styled-components/PdfFormNote';
import StyledSignatureBlock from 'modules/map/components/pdf-print-form/styled-components/StyledSignatureBlock';

interface SixDaysFormFooterProps {
  footerInfo: StructuredDataInfo;
}

const SixDaysFormFooter: FC<SixDaysFormFooterProps> = (props) => {
  const { footerInfo } = props;
  const today = dayjs().format('DD-MM-YYYY');
  const fontSize = SMALL_FONT_SIZE;
  const marginFooter = '70px';

  return (
    <>
      <PdfFormNote />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize,
            fontStyle: 'italic',
          }}
        >
          Thực đơn gửi trường ngày: {today}
        </Typography>
        <Box sx={{ mr: SMALL_FONT_SIZE }}>
          <Typography sx={{ fontWeight: 600, fontSize }}>
            {footerInfo.city}, ngày.........tháng..........năm {footerInfo.year}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <StyledSignatureBlock value="Người lập" />
        <StyledSignatureBlock value="Chuyên viên dinh dưỡng" />
        <StyledSignatureBlock value="Bếp trưởng" />
        <StyledSignatureBlock value="Đại diện nhà trường" />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: marginFooter,
        }}
      >
        <StyledSignatureBlock value={footerInfo.menuAccountingOfficer} />
        <StyledSignatureBlock value={footerInfo.nutritionSpecialist} />
        <StyledSignatureBlock value={footerInfo.chef} />
        <StyledSignatureBlock value="" />
      </Box>
    </>
  );
};

export default SixDaysFormFooter;
